import React from "react";
import { Link } from "react-router-dom";
import moment from "moment";

const DependentTable = ({
  dependents,
  editClick,
  removeClick,
  activeParameter,
  user,
}) => {
  return (
    <table className="table">
      <thead>
        <tr>
          <th>Sequence</th>
          <th>Parameter</th>
          <th>Heading</th>
          <th>Type</th>
          <th></th>
          <th>Last Updated</th>
          <th>Updated By</th>
          <th></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {dependents.map((parameter) => (
          <tr key={parameter.ID}>
            <td className="align-middle">{parameter.SEQUENCE}</td>
            <td className="text-nowrap align-middle">
              <Link to={`/parameters/${parameter.DEPENDENT}`}>
                {parameter.DEPENDENT}
              </Link>
            </td>
            <td>{parameter.NAME}</td>
            <td>
              <span className="badge badge-warning">{parameter.TYPE}</span>
            </td>
            <td className="text-nowrap align-middle">
              {moment(parameter.LAST_UPDATED_DTS).fromNow()}
            </td>
            <td className="align-middle">{parameter.LAST_UPDATED_BY}</td>
            <td className="align-middle">
              {user && activeParameter.PTYP_CODE === "SIM" && (
                <button
                  className="btn btn-primary btn-sm"
                  onClick={() => editClick(parameter)}
                  disabled={
                    (user.SITE !== "CO" &&
                      activeParameter.LOCAL_FLAG === "N") ||
                    (user.SITE === "CO" && activeParameter.LOCAL_FLAG === "Y")
                  }
                >
                  Edit
                </button>
              )}
            </td>
            <td className="align-middle">
              {user && (
                <button
                  className="btn btn-danger btn-sm"
                  onClick={() => removeClick(parameter)}
                  disabled={
                    (user.SITE !== "CO" &&
                      activeParameter.LOCAL_FLAG === "N") ||
                    (user.SITE === "CO" && activeParameter.LOCAL_FLAG === "Y")
                  }
                >
                  Remove
                </button>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default DependentTable;
